import { LoadingButton } from '@mui/lab'
import { styled } from '@mui/material'
import { Colors } from 'constants/colors'

export const LinkButton = styled(LoadingButton)({
  color: Colors.MAROON,
  textAlign: 'left',
  textDecoration: 'underline',
  textTransform: 'none',
  background: 'none',
  ':hover': {
    background: 'none',
  },
})
